import { takeEvery, put, call, select } from "redux-saga/effects";
import endpoints, { endpointTypes } from "../../service";
import { fetchAPI } from "../../utils/service";
import { getPersistData, parseObject } from "../../utils/utils";
import * as reportActionTypes from "./actionTypes";
import * as reportActionCreators from "./actionCreators";

const reportRoute = endpoints[endpointTypes.OPERATIONAL_REPORT];

const createRequestObj = (data) => {
    const reqObj = {
        CustomerId: data.customerId,
        FromDate: data.startDate,
        ToDate: data.endDate,
        // reportType: data.isTypeOptSelected
    };
    return reqObj;
};

export function* fetchOperationalReport(action) {
    const reqObj = createRequestObj(action.payload);
    const endpoint = reportRoute.endpoints.getOperationalReport(reqObj, action.payload.isTypeOptSelected);
    
    try {
        const response = yield call(fetchAPI, endpoint);
        if (response.data) {
            yield put(reportActionCreators.getReportSuccess(response.data));
        } else {
            yield put(reportActionCreators.getReportFailure(new Error(JSON.stringify(response))));
        }
    } catch (err) {
        yield put(reportActionCreators.getReportFailure(err));
    }
}

export function* operationalReportWatcher() {
    yield takeEvery(reportActionTypes.GET_WARRANTIES_REPORT, fetchOperationalReport);
}